import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { Role } from './core/enums/role.enum';

export const routes: Routes = [
  // Default redirect
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },

  {
    path: 'shipment/:shipmentId',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./shipment-traceability/pages/shipment-traceability-page/shipment-traceability-page.component').then(
        (m) => m.ShipmentTraceabilityPageComponent,
      ),
  },

  // Auth (public)
  {
    path: 'auth',
    component: AuthLayoutComponent,
    loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },

  // Super Admin
  {
    path: 'super-admin',
    component: DashboardLayoutComponent,
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.SUPER_ADMIN] },
    loadChildren: () =>
      import('./super-admin/super-admin.routes').then((m) => m.SUPER_ADMIN_ROUTES),
  },

  // Farm
  {
    path: 'farm',
    component: DashboardLayoutComponent,
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.FARM] },
    loadChildren: () => import('./farm/farm.routes').then((m) => m.FARM_ROUTES),
  },

  // Facility
  {
    path: 'facility',
    component: DashboardLayoutComponent,
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.FACILITY] },
    loadChildren: () => import('./facility/facility.routes').then((m) => m.FACILITY_ROUTES),
  },

  // Customer
  {
    path: 'customer',
    component: DashboardLayoutComponent,
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.CUSTOMER] },
    loadChildren: () => import('./customer/customer.routes').then((m) => m.CUSTOMER_ROUTES),
  },

  // Inward
  {
    path: 'inward',
    component: DashboardLayoutComponent,
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.INWARD] },
    loadChildren: () => import('./inward/inward.routes').then((m) => m.INWARD_ROUTES),
  },

  // Grade In
  {
    path: 'grade-in',
    component: DashboardLayoutComponent,
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.GRADE_IN] },
    loadChildren: () => import('./grade-in/grade-in.routes').then((m) => m.GRADE_IN_ROUTES),
  },

  // Grade Out
  {
    path: 'grade-out',
    component: DashboardLayoutComponent,
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.GRADE_OUT] },
    loadChildren: () => import('./grade-out/grade-out.routes').then((m) => m.GRADE_OUT_ROUTES),
  },

  // Packing
  {
    path: 'packing',
    component: DashboardLayoutComponent,
    canActivate: [authGuard, roleGuard],
    data: { roles: [Role.PACKING] },
    loadChildren: () => import('./packing/packing.routes').then((m) => m.PACKING_ROUTES),
  },

  // Wildcard
  { path: '**', redirectTo: 'auth/login' },
];
